import axios from 'axios';
import store from '../store/index.js';
import Auth from '@aws-amplify/auth';
import { logError } from '@/utils/loggerUtils.js';

axios.defaults.timeout = 60000;

const esApiClient = axios.create({
  baseURL: process.env.VUE_APP_ES_API_URL,
  authRequired: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

esApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    logError(error);
    if (error.response && error.response.status === 401) {
      store.dispatch('logout');
    }
    return Promise.reject(error);
  }
);

export default {
  async searchQuestionStd(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/searchquestionstd', { params: fields });
  },
  async getTermsStd(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/gettermsstd', { params: fields });
  },
  async searchFields(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/searchfields', { params: fields });
  },
  async searchDrug(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/searchDrug', { params: fields });
  },
  async searchRegDocPage(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/searchregdocpage', { params: fields });
  },
  async getTermsRegDocPage(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/gettermsregdocpage', { params: fields });
  },
  async getCompositeTermsRegDocPage(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getcompositetermsregdocpage', { params: fields });
  },
  async getEndpointsRegDocPage(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getendpointsregdocpage', { params: fields });
  },
  async getDateHistogramRegDocPage(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/gethistogramregdocpage', { params: fields });
  },
  async getMinMaxFieldValues(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getminmaxregdocpage', { params: fields });
  },
  async getTableRegDocPage(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/gettableregdocpage', { params: fields });
  },
  async getDatabaseStats(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getdbstats', { params: fields });
  },
  async getRssFeeds(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getrssfeeds', { params: fields });
  },
  async getTrialInfo(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/gettrialinfo', { params: fields });
  },
  async getMatchingFieldValues(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getmatchingfieldvalues', { params: fields });
  },
  async getDataset(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getdataset', { params: fields });
  },
  async getDatasetProducts(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/getdatasetproducts', { params: fields });
  },
  async getTrialIds(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/gettrialids', { params: fields });
  },
  async searchTrialAttributes(fields) {
    esApiClient.defaults.headers.common['Authorization'] = `Bearer ${(
      await Auth.currentSession()
    )
      .getIdToken()
      .getJwtToken()}`;
    return esApiClient.get('/searchtrialattrs', { params: fields });
  },
};
